import { render, staticRenderFns } from "./usersAdd.vue?vue&type=template&id=35395c9b&scoped=true&"
import script from "./usersAdd.vue?vue&type=script&lang=js&"
export * from "./usersAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35395c9b",
  null
  
)

export default component.exports